import { useCallback, useRef } from 'react';
import { useStoreActions } from '~/contexts';
export function useStudioCloseGate(args) {
    const { onClose, shouldClose } = args;
    const { logBI } = useStoreActions();
    const hasUnsavedChangesRef = useRef(false);
    const setHasUnsavedChanges = useCallback((value)=>{
        hasUnsavedChangesRef.current = value;
    }, []);
    const requestClose = ()=>{
        logBI(10480);
        const gate = shouldClose !== null && shouldClose !== void 0 ? shouldClose : async ()=>true;
        gate(hasUnsavedChangesRef.current).then((confirmed)=>{
            if (confirmed) onClose();
        });
    };
    return {
        requestClose,
        setHasUnsavedChanges
    };
}
